import classNames from 'classnames'
import React, { FC, useContext, useEffect } from 'react'
import Dropdown from '~/components/common/Dropdown'
import Tooltip from '~/components/common/Tooltip'
import { ChatContext } from '~/service/chatConn'
import { FormType } from '..'
import { Control, Controller } from 'react-hook-form'
import { RenderPropsTyped } from '~/components/common/Form'

type Props = {
  control: Control<FormType, any>
  redirectToStory?: number
}

const Redirect: FC<Props> = ({ control, redirectToStory }) => (
  <Controller
    name="redirectToUser"
    control={control}
    render={renderProps => (
      <RedirectField
        renderProps={renderProps}
        redirectToStory={redirectToStory}
      />
    )}
  />
)

export default Redirect

type RedirectFieldProps = {
  renderProps: RenderPropsTyped<FormType, 'redirectToUser'>
  redirectToStory?: number
}

const RedirectField: FC<RedirectFieldProps> = ({
  renderProps,
  redirectToStory,
}) => {
  const { loadUsersRedirectList } = useContext(ChatContext)
  const {
    field: { value: redirectToUser, onChange },
  } = renderProps

  useEffect(() => {
    loadUsersRedirectList()
  }, [])

  return (
    <Dropdown
      // right={true}
      up={true}
      trigger={
        <Tooltip
          content={intl.formatMessage({
            id: 'chat / input / redirect / tooltip',
          })}
        >
          <button type="button" disabled={!!redirectToStory}>
            <span className="far fa-share" />
          </button>
        </Tooltip>
      }
    >
      <Inner onSelect={id => onChange(id)} selected={redirectToUser} />
    </Dropdown>
  )
}

type InnerProps = {
  onSelect: (id?: number) => void
  selected?: number
}

const Inner: FC<InnerProps> = ({ onSelect, selected }) => {
  const { loadUsersRedirectList, usersOnRedirectList } = useContext(ChatContext)

  useEffect(() => {
    loadUsersRedirectList()
  }, [])

  if (!usersOnRedirectList) {
    return (
      <div className="dropdown-loading">
        <span className="fa fa-spinner-third fa-spin" />
      </div>
    )
  }

  if (!usersOnRedirectList.length) {
    return (
      <div className="dropdown-item">
        {intl.formatMessage({
          id: 'chat / input / redirect / no agents',
        })}
      </div>
    )
  }

  return (
    <>
      <div className="dropdown-item">
        {intl.formatMessage({
          id: 'chat / input / redirect / label',
        })}
        :
      </div>

      {/* {testUsers.map(user => ( */}
      {usersOnRedirectList.map(user => (
        <a
          key={user.saasId}
          className={classNames('dropdown-item dropdown-item-withAvatar', {
            'is-active': selected == user.saasId,
          })}
          onClick={() => onSelect(user.saasId)}
        >
          <img src={user.userData.avatar} />
          {user.userData.name}
        </a>
      ))}
    </>
  )
}

// const testUsers = [
//   {
//     saasId: 7995,
//     userData: {
//       id: 2,
//       name: 'kuba@example.com',
//       avatar: 'https://avatar.limtel.com/avatar?text=kuba',
//       admin: true,
//       supervisor: false,
//       removed: false,
//       guest: false,
//       online: false,
//       chatAccounts: [
//         {
//           id: 2,
//           login: 'jakubzawislakchatbot4@xmpp.inteliwise.com',
//           organisationId: 2,
//         },
//       ],
//     },
//     skills: [
//       {
//         id: 949,
//         name: 'Dział pierwszy222',
//       },
//     ],
//   },
//   {
//     saasId: 9867,
//     userData: {
//       id: 4,
//       name: 'Halina',
//       avatar: 'https://avatar.limtel.com/avatar?text=Halina4',
//       admin: false,
//       supervisor: false,
//       removed: false,
//       guest: false,
//       online: false,
//       chatAccounts: [
//         {
//           id: 3,
//           login: 'halina4@xmpp.inteliwise.com',
//           organisationId: 2,
//         },
//       ],
//     },
//     skills: [
//       {
//         id: 949,
//         name: 'Dział pierwszy222',
//       },
//     ],
//   },
// ] as UserOnRedirectList[]
